import { promiseTimeout, whenever } from "@vueuse/core";
import { ref } from "vue";

const ONE_SECOND = 1000;
const ERROR_TIMEOUT = ONE_SECOND * 4;

const error = ref();
const isHiddenTemporarily = ref(false);

export function useState() {
  whenever(error, scheduleClearError);

  async function scheduleClearError() {
    await promiseTimeout(ERROR_TIMEOUT);
    clearError();
  }

  function setError(message) {
    error.value = message;
  }

  function clearError() {
    error.value = undefined;
  }

  return {
    error,
    isHiddenTemporarily,

    setHideTemporarily: (value) => (isHiddenTemporarily.value = value),

    setError,
    clearError,
  };
}
